export const enum OptionEnum {
  wrong = "wrong",
  correct = "correct",
  vote = "vote",
}

export const enum OptionTypeEnum {
  quiz = "quiz",
  poll = "poll",
  voting = "voting",
}

export const enum OptionModeEnum {
  normal = "normal",
  results = "results",
  voted = "voted",
}

export { ImageOption } from "./ImageOption/ImageOption";
export { ImageOptionExtended } from "./ImageOption/ImageOptionExtended";
export { TextOption } from "./TextOption/TextOption";
